<template>
  <div class="rdpd-root">
    <!-- Estado de carregamento: silencioso, não ocupa espaço visual no print -->
    <div v-if="!loading && resident">
      <table>
        <tbody>
          <tr>
            <td style="width: 10% !important">
              <img
                v-if="resident.rest_home_logo_url"
                class="rest_home_logo_url"
                :src="resident.rest_home_logo_url"
              />
              <div v-if="!resident.rest_home_logo_url">
                <strong class="text-uppercase">{{
                  resident.rest_home_name
                }}</strong>
              </div>
            </td>
            <td style="width: 70% !important" class="d-flex align-items-center">
              <img
                v-if="resident.photo_url"
                class="resident_photo_url"
                :src="resident.photo_url"
              />
              <img
                v-if="!resident.photo_url"
                class="resident_photo_url"
                :src="require('../../assets/user.png')"
              />
              <div class="ml-2">
                <p v-if="resident.name" class="legends m-0 worksansr">
                  <strong>Nome:</strong>
                  {{ resident.name }}
                </p>
                <p
                  v-if="
                    isSection('general') &&
                    isField('general', 'date_of_birth') &&
                    resident.date_of_birth
                  "
                  class="legends m-0 worksansr"
                >
                  <strong>Nascimento:</strong>
                  {{ formatDate(resident.date_of_birth, false) }} —
                  {{ getAge(resident.date_of_birth) }} anos
                </p>

                <p
                  v-if="
                    isSection('general') &&
                    isField('general', 'gender_id') &&
                    resident.gender_name
                  "
                  class="legends m-0 worksansr"
                >
                  <strong>Gênero:</strong> {{ resident.gender_name }}
                </p>

                <p
                  v-if="
                    isSection('docs') && isField('docs', 'cpf') && resident.cpf
                  "
                  class="legends m-0 worksansr"
                >
                  <strong>CPF:</strong> {{ resident.cpf }}
                </p>

                <p
                  v-if="isSection('address') && hasAddressData"
                  class="legends m-0 worksansr"
                >
                  <!-- Endereço composto em linha única para economizar altura no cabeçalho -->
                  <span
                    v-if="isField('address', 'address') && resident.address"
                  >
                    <strong>Endereço:</strong> {{ resident.address }}
                  </span>
                  <span
                    v-if="
                      isField('address', 'number_address') &&
                      resident.number_address
                    "
                  >
                    , {{ resident.number_address }}
                  </span>
                  <span
                    v-if="
                      isField('address', 'complement') && resident.complement
                    "
                  >
                    — {{ resident.complement }}
                  </span>
                  <span
                    v-if="
                      isField('address', 'neighborhood') &&
                      resident.neighborhood
                    "
                  >
                    , {{ resident.neighborhood }}
                  </span>
                  <span v-if="isField('address', 'city') && resident.city">
                    , {{ resident.city }}
                  </span>
                  <span v-if="isField('address', 'uf_id') && resident.uf_name">
                    /{{ resident.uf_name }}
                  </span>
                  <span v-if="isField('address', 'cep') && resident.cep">
                    — <strong>CEP:</strong> {{ resident.cep }}
                  </span>
                  <span
                    v-if="isField('address', 'reference') && resident.reference"
                  >
                    — <strong>Ref.:</strong> {{ resident.reference }}
                  </span>
                </p>

                <p
                  v-if="
                    isSection('docs') && isField('docs', 'rg') && resident.rg
                  "
                  class="legends m-0 worksansr"
                >
                  <strong>RG:</strong> {{ resident.rg }}
                  <span
                    v-if="
                      isSection('docs') &&
                      isField('docs', 'issuing_body') &&
                      resident.issuing_body
                    "
                  >
                    <strong>/</strong> {{ resident.issuing_body }}
                  </span>
                  <span
                    v-if="
                      isSection('docs') &&
                      isField('docs', 'date_of_issue') &&
                      resident.date_of_issue
                    "
                  >
                    <strong>emitido em:</strong>
                    {{ formatDate(resident.date_of_issue, false) }}
                  </span>
                </p>

                <p
                  v-if="
                    isSection('docs') &&
                    isField('docs', 'SUS_card_number') &&
                    resident.SUS_card_number
                  "
                  class="legends m-0 worksansr"
                >
                  <strong>Cartão SUS:</strong>
                  {{ resident.SUS_card_number }}
                </p>

                <p
                  v-if="isSection('docs') && hasINSSData"
                  class="legends m-0 worksansr"
                >
                  <span
                    v-if="
                      isField('docs', 'INSS_benefit_number') &&
                      resident.INSS_benefit_number
                    "
                  >
                    <strong>INSS Nº:</strong>
                    {{ resident.INSS_benefit_number }}
                  </span>
                  <span
                    v-if="
                      isField('docs', 'type_of_INSS_benefit') &&
                      resident.type_of_INSS_benefit
                    "
                  >
                    — <strong>Tipo:</strong>
                    {{ resident.type_of_INSS_benefit }}
                  </span>
                  <span
                    v-if="
                      isField('docs', 'inss_benefit_status_id') &&
                      resident.inss_benefit_status_name
                    "
                  >
                    — <strong>Situação:</strong>
                    {{ resident.inss_benefit_status_name }}
                  </span>
                  <span
                    v-if="
                      isField('docs', 'INSS_benefit_amount') &&
                      resident.INSS_benefit_amount
                    "
                  >
                    — <strong>Valor:</strong>
                    {{ resident.INSS_benefit_amount }}
                  </span>
                  <span
                    v-if="
                      isField('docs', 'INSS_update_date') &&
                      resident.INSS_update_date
                    "
                  >
                    — <strong>Atualizado em:</strong>
                    {{ formatDate(resident.INSS_update_date, false) }}
                  </span>
                </p>

                <p v-if="isSection('hosting')" class="legends m-0 worksansr">
                  <!-- Tipo de hospedagem -->
                  <span
                    v-if="
                      isField('hosting', 'type_of_hosting_id') &&
                      resident.type_of_hosting_name
                    "
                    class="legends mb-0 worksansr mr-2"
                  >
                    <strong>Hospedagem:</strong>
                    {{ resident.type_of_hosting_name }}
                  </span>

                  <!-- Data de admissão -->
                  <span
                    v-if="
                      isField('hosting', 'date_of_reception') &&
                      resident.date_of_reception
                    "
                    class="legends mb-0 worksansr mr-2"
                  >
                    <strong>Admissão:</strong>
                    {{ formatDate(resident.date_of_reception, false) }}
                  </span>

                  <!-- Leito — agrupado em uma linha para economizar espaço vertical -->
                  <span
                    v-if="isField('hosting', 'bed_id') && resident.bed_id"
                    class="legends mb-0 worksansr mr-2"
                  >
                    <strong>Leito Nº:</strong> {{ resident.bed_number }}
                    <template v-if="resident.bed_walk"
                      >, <strong>Andar:</strong>
                      {{ resident.bed_walk }}</template
                    >
                    <template v-if="resident.bed_ward_or_sector"
                      >, <strong>ALA/Setor:</strong>
                      {{ resident.bed_ward_or_sector }}</template
                    >
                    <template v-if="resident.bed_bedroom"
                      >, <strong>Quarto:</strong>
                      {{ resident.bed_bedroom }}</template
                    >
                  </span>

                  <!-- Motivo da hospedagem -->
                  <span
                    v-if="
                      isField('hosting', 'reason_for_the_reception') &&
                      resident.reason_for_the_reception
                    "
                    class="legends mb-0 worksansr mr-2"
                  >
                    <strong>Motivo:</strong>
                    {{ resident.reason_for_the_reception }}
                  </span>

                  <!-- Valor da mensalidade -->
                  <span
                    v-if="
                      isField('hosting', 'income_monthly_fee') &&
                      resident.income_monthly_fee
                    "
                    class="legends mb-0 worksansr mr-2"
                  >
                    <strong>Mensalidade:</strong>
                    {{ resident.income_monthly_fee }}
                  </span>

                  <!-- Vencimento do contrato -->
                  <span
                    v-if="
                      isField('hosting', 'date_end_contract') &&
                      resident.date_end_contract
                    "
                    class="legends mb-0 worksansr mr-2"
                  >
                    <strong>Vencimento do contrato:</strong>
                    {{ formatDate(resident.date_end_contract, false) }}
                  </span>
                </p>
              </div>
            </td>
            <td style="width: 10% !important">
              <img class="logo" :src="logo" />
            </td>
          </tr>
        </tbody>
      </table>

      <!-- ── SEÇÃO: GERAL ──────────────────────────────────────────── -->
      <template v-if="isSection('general')">
        <div class="p-2">
          <div class="content-data-card">
            <!-- Nome — tratado fora do loop pois tem hierarquia visual própria -->
            <h6
              v-if="isField('general', 'nickname') && resident.nickname"
              class="legends mb-0 worksansr"
            >
              <strong>Apelido:</strong> {{ resident.nickname }}
            </h6>

            <!-- Prontuário -->
            <h6
              v-if="
                isField('general', 'medical_record_number') &&
                resident.medical_record_number
              "
              class="legends mb-0 worksansr"
            >
              <strong>Prontuário:</strong> {{ resident.medical_record_number }}
            </h6>

            <!-- Estado civil -->
            <h6
              v-if="
                isField('general', 'marital_status_id') &&
                resident.marital_status_name
              "
              class="legends mb-0 worksansr"
            >
              <strong>Estado civil:</strong> {{ resident.marital_status_name }}
            </h6>

            <!-- Status -->
            <h6
              v-if="
                isField('general', 'status_type_id') &&
                resident.status_type_name
              "
              class="legends mb-0 worksansr"
            >
              <strong>Status:</strong> {{ resident.status_type_name }}
            </h6>

            <!-- Telefone -->
            <h6
              v-if="isField('general', 'phone') && resident.phone"
              class="legends mb-0 worksansr"
            >
              <strong>Telefone:</strong> {{ resident.phone }}
            </h6>

            <!-- Grau de dependência -->
            <h6
              v-if="
                isField('general', 'degree_of_dependence_id') &&
                resident.degree_of_dependence_name
              "
              class="legends mb-0 worksansr"
            >
              <strong>Dependência:</strong>
              {{ resident.degree_of_dependence_name }}
            </h6>

            <!-- Tipo de alimentação -->
            <h6
              v-if="isField('general', 'type_of_food') && resident.type_of_food"
              class="legends mb-0 worksansr"
            >
              <strong>Alimentação:</strong> {{ resident.type_of_food }}
            </h6>

            <!-- Patologia -->
            <h6
              v-if="isField('general', 'pathology') && resident.pathology"
              class="legends mb-0 worksansr"
            >
              <strong>Patologia:</strong> {{ resident.pathology }}
            </h6>

            <!-- Naturalidade -->
            <h6
              v-if="isField('general', 'naturalness') && resident.naturalness"
              class="legends mb-0 worksansr"
            >
              <strong>Naturalidade:</strong> {{ resident.naturalness }}
            </h6>

            <!-- Religião -->
            <h6
              v-if="isField('general', 'religion') && resident.religion"
              class="legends mb-0 worksansr"
            >
              <strong>Religião:</strong> {{ resident.religion }}
            </h6>

            <!-- Profissão -->
            <h6
              v-if="isField('general', 'profession') && resident.profession"
              class="legends mb-0 worksansr"
            >
              <strong>Profissão:</strong> {{ resident.profession }}
            </h6>

            <!-- Escolaridade -->
            <h6
              v-if="isField('general', 'schooling') && resident.schooling"
              class="legends mb-0 worksansr"
            >
              <strong>Escolaridade:</strong> {{ resident.schooling }}
            </h6>

            <!-- Nome do pai -->
            <h6
              v-if="isField('general', 'fathers_name') && resident.fathers_name"
              class="legends mb-0 worksansr"
            >
              <strong>Pai:</strong> {{ resident.fathers_name }}
            </h6>

            <!-- Nome da mãe -->
            <h6
              v-if="isField('general', 'mothers_name') && resident.mothers_name"
              class="legends mb-0 worksansr"
            >
              <strong>Mãe:</strong> {{ resident.mothers_name }}
            </h6>

            <!-- Cônjuge -->
            <h6
              v-if="isField('general', 'spouse') && resident.spouse"
              class="legends mb-0 worksansr"
            >
              <strong>Cônjuge:</strong> {{ resident.spouse }}
            </h6>

            <!-- Observações -->
            <h6
              v-if="isField('general', 'comments') && resident.comments"
              class="legends mb-0 worksansr"
            >
              <strong>Obs.:</strong> {{ resident.comments }}
            </h6>
          </div>
        </div>
      </template>

      <!-- ── SEÇÃO: CONVÊNIOS ─────────────────────────────────────── -->
      <!--
        Convênios podem ser múltiplos (array).
        A API deve retornar resident.agreements como array de objetos.
        Se vier como objeto único, é normalizado no created().
      -->
      <template v-if="isSection('agreement') && agreements.length > 0">
        <div class="p-2">
          <h6
            v-for="(agreement, index) in agreements"
            :key="index"
            class="legends m-0 worksansr content-data-card"
          >
            <strong>Convênio:</strong>
            <template
              v-if="
                isField('agreement', 'covenant_name') && agreement.covenant_name
              "
            >
              {{ agreement.covenant_name }}
            </template>
            <template
              v-if="
                isField('agreement', 'type_of_agreement_id') &&
                agreement.type_of_agreement_name
              "
            >
              ({{ agreement.type_of_agreement_name }})
            </template>
            <template v-if="isField('agreement', 'number') && agreement.number">
              — <strong>Carteirinha:</strong> {{ agreement.number }}
            </template>
            <template
              v-if="
                isField('agreement', 'type_plan_name') &&
                agreement.type_plan_name
              "
            >
              — <strong>Plano:</strong> {{ agreement.type_plan_name }}
            </template>
            <template
              v-if="
                isField('agreement', 'exchange_phone') &&
                agreement.exchange_phone
              "
            >
              — <strong>Central:</strong> {{ agreement.exchange_phone }}
            </template>
            <template v-if="isField('agreement', 'name') && agreement.name">
              — <strong>Titular:</strong> {{ agreement.name }}
            </template>
            <template
              v-if="
                isField('agreement', 'type_of_customer_id') &&
                agreement.type_of_customer_name
              "
            >
              ({{ agreement.type_of_customer_name }})
            </template>
            <template v-if="isField('agreement', 'phone') && agreement.phone">
              — <strong>Tel:</strong> {{ agreement.phone }}
            </template>
            <template
              v-if="isField('agreement', 'cell_phone') && agreement.cell_phone"
            >
              / {{ agreement.cell_phone }}
            </template>

            <template
              v-if="isField('agreement', 'address') && agreement.address"
            >
              {{ agreement.address }}
            </template>
            <template
              v-if="
                isField('agreement', 'number_address') &&
                agreement.number_address
              "
            >
              , {{ agreement.number_address }}
            </template>
            <template
              v-if="isField('agreement', 'complement') && agreement.complement"
            >
              — {{ agreement.complement }}
            </template>
            <template
              v-if="
                isField('agreement', 'neighborhood') && agreement.neighborhood
              "
            >
              , {{ agreement.neighborhood }}
            </template>
            <template v-if="isField('agreement', 'city') && agreement.city">
              , {{ agreement.city }}
            </template>
            <template v-if="isField('agreement', 'uf_id') && agreement.uf_name">
              /{{ agreement.uf_name }}
            </template>
            <template v-if="isField('agreement', 'cep') && agreement.cep">
              — <strong>CEP:</strong> {{ agreement.cep }}
            </template>
            <template
              v-if="isField('agreement', 'reference') && agreement.reference"
            >
              — <strong>Ref.:</strong> {{ agreement.reference }}
            </template>

            <template v-if="isField('agreement', 'note') && agreement.note">
              — <strong>Obs:</strong> {{ agreement.note }}
            </template>
          </h6>
        </div>
      </template>

      <template v-if="isSection('general')">
        <div class="p-2">
          <div class="content-data-card">
            <!-- Diagnósticos -->
            <h6
              v-if="isField('general', 'diagnosis') && resident.diagnosis"
              class="legends mb-0 worksansr"
            >
              <strong>Diagnósticos:</strong> {{ resident.diagnosis }}
            </h6>

            <!-- Alergias diversas -->
            <h6
              v-if="
                isField('general', 'miscellaneous_allergies') &&
                resident.miscellaneous_allergies
              "
              class="legends mb-0 worksansr"
            >
              <strong>Alergias:</strong> {{ resident.miscellaneous_allergies }}
            </h6>

            <!-- IMC -->
            <h6
              v-if="isField('general', 'imc') && resident.imc"
              class="legends mb-0 worksansr"
            >
              <strong>IMC:</strong> {{ resident.imc.imc }}
              <strong>Altura:</strong> {{ resident.height }}
              <strong>Peso:</strong>
              {{ resident.weight }}
            </h6>

            <!-- Plano de saúde -->
            <h6
              v-if="
                isField('general', 'health_plan') ||
                isField('general', 'health_plan_plan') ||
                isField('general', 'health_plan_registration')
              "
              class="legends mb-0 worksansr"
            >
              <span v-if="resident.health_plan">
                <strong>Plano de saúde:</strong> {{ resident.health_plan }}
              </span>
              <span v-if="resident.health_plan_plan">
                <strong>Plano:</strong> {{ resident.health_plan_plan }}
              </span>
              <span v-if="resident.health_plan_registration">
                <strong>Matrícula:</strong>
                {{ resident.health_plan_registration }}
              </span>
            </h6>

            <!-- Hospital -->
            <h6
              v-if="
                isField('general', 'hospital') ||
                isField('general', 'hospital_address')
              "
              class="legends mb-0 worksansr"
            >
              <span v-if="resident.hospital">
                <strong>Hospital:</strong> {{ resident.hospital }}
              </span>
              <span v-if="resident.hospital_address">
                <strong>Endereço:</strong> {{ resident.hospital_address }}
              </span>
            </h6>

            <!-- Ambulância -->
            <h6
              v-if="isField('general', 'ambulance') && resident.ambulance"
              class="legends mb-0 worksansr"
            >
              <strong>Ambulância:</strong> {{ resident.ambulance }}
            </h6>

            <!-- Profissionais de saúde -->
            <h6
              v-if="
                isField('general', 'healthcare_professionals') &&
                resident.healthcare_professionals
              "
              class="legends mb-0 worksansr"
            >
              <strong>Profissionais de saúde:</strong>
              {{ resident.healthcare_professionals }}
            </h6>
          </div>
        </div>
      </template>

      <template
        v-if="
          isSection('general') && isField('general', 'diets') && resident.diets
        "
      >
        <div class="p-2">
          <div class="content-data-card">
            <!-- Dietas -->
            <h6 class="legends mb-0 worksansr">
              <strong>Dietas:</strong> {{ resident.diets }}
            </h6>
          </div>
        </div>
      </template>
    </div>
    <!-- /loading guard -->
  </div>
</template>

<script>
import { formatDate } from "../../lib/format";

import { userData } from "../../lib/functions";

import { getAge } from "../../lib/getAgeByDate";

import api from "../../services/api";

const DEFAULT_PRINT_SECTIONS = [
  {
    key: "general",
    label: "Geral",
    selected: true,
    fields: [
      { key: "name", selected: true },
      { key: "medical_record_number", selected: true },
      { key: "gender_id", selected: true },
      { key: "date_of_birth", selected: true },
      { key: "status_type_id", selected: false },
      { key: "phone", selected: false },
      { key: "degree_of_dependence_id", selected: true },
      { key: "type_of_food", selected: false },
      { key: "pathology", selected: false },
      { key: "miscellaneous_allergies", selected: false },
      { key: "nickname", selected: false },
      { key: "naturalness", selected: false },
      { key: "marital_status_id", selected: true },
      { key: "religion", selected: false },
      { key: "profession", selected: false },
      { key: "schooling", selected: false },
      { key: "fathers_name", selected: false },
      { key: "mothers_name", selected: false },
      { key: "spouse", selected: false },
      { key: "comments", selected: false },
      { key: "imc", selected: false },
      { key: "diagnosis", selected: false },
      { key: "health_plan", selected: false },
      { key: "health_plan_plan", selected: false },
      { key: "health_plan_registration", selected: false },
      { key: "hospital", selected: false },
      { key: "hospital_address", selected: false },
      { key: "ambulance", selected: false },
      { key: "healthcare_professionals", selected: false },
      { key: "diets", selected: false },
    ],
  },
  {
    key: "address",
    label: "Endereço",
    selected: false,
    fields: [
      { key: "cep", selected: true },
      { key: "address", selected: true },
      { key: "number_address", selected: true },
      { key: "neighborhood", selected: true },
      { key: "city", selected: true },
      { key: "uf_id", selected: true },
      { key: "complement", selected: false },
      { key: "reference", selected: false },
    ],
  },
  {
    key: "docs",
    label: "Documentos",
    selected: false,
    fields: [
      { key: "cpf", selected: true },
      { key: "rg", selected: true },
      { key: "issuing_body", selected: true },
      { key: "date_of_issue", selected: true },
      { key: "SUS_card_number", selected: true },
      { key: "INSS_benefit_number", selected: false },
      { key: "type_of_INSS_benefit", selected: false },
      { key: "inss_benefit_status_id", selected: false },
      { key: "INSS_benefit_amount", selected: false },
      { key: "INSS_update_date", selected: false },
    ],
  },
  {
    key: "agreement",
    label: "Convênios",
    selected: false,
    fields: [
      { key: "type_of_agreement_id", selected: true },
      { key: "covenant_name", selected: true },
      { key: "number", selected: true },
      { key: "type_plan_name", selected: true },
      { key: "exchange_phone", selected: true },
      { key: "name", selected: true },
      { key: "type_of_customer_id", selected: true },
      { key: "phone", selected: true },
      { key: "cell_phone", selected: false },
      { key: "note", selected: false },
      { key: "cep", selected: false },
      { key: "address", selected: false },
      { key: "number_address", selected: false },
      { key: "neighborhood", selected: false },
      { key: "city", selected: false },
      { key: "uf_id", selected: false },
      { key: "reference", selected: false },
      { key: "complement", selected: false },
    ],
  },
  {
    key: "hosting",
    label: "Hospedagem",
    selected: true,
    fields: [
      { key: "type_of_hosting_id", selected: true },
      { key: "date_of_reception", selected: true },
      { key: "bed_id", selected: true },
      { key: "income_monthly_fee", selected: false },
      { key: "reason_for_the_reception", selected: false },
      { key: "date_end_contract", selected: false },
    ],
  },
];

export default {
  name: "ResidentDataPrintDefault",

  props: {
    resident_id: {
      type: [String, Number],
      required: false,
    },
    created_at: {
      type: [String],
      required: false,
      default: "",
    },
  },

  data() {
    return {
      logo: null,

      loading: true,
      resident: null,

      configMap: {},
    };
  },

  computed: {
    agreements() {
      if (!this.resident) return [];
      const raw = this.resident.agreements;
      if (!raw) return [];
      return Array.isArray(raw) ? raw : [raw];
    },

    hasAddressData() {
      if (!this.resident) return false;
      const addressFields = [
        "address",
        "number_address",
        "complement",
        "neighborhood",
        "city",
        "uf_id",
        "cep",
        "reference",
      ];
      return addressFields.some(
        (key) =>
          this.isField("address", key) &&
          this.resident[key === "uf_id" ? "uf_name" : key]
      );
    },

    /**
     * Evita renderizar linha INSS vazia.
     */
    hasINSSData() {
      if (!this.resident) return false;
      const inssFields = [
        "INSS_benefit_number",
        "type_of_INSS_benefit",
        "inss_benefit_status_id",
        "INSS_benefit_amount",
        "INSS_update_date",
      ];
      return inssFields.some(
        (key) =>
          this.isField("docs", key) &&
          this.resident[
            key === "inss_benefit_status_id" ? "inss_benefit_status_name" : key
          ]
      );
    },
  },

  watch: {
    resident_id: {
      immediate: true,
      handler(val) {
        if (!val) return;
        this.init();
      },
    },
  },

  methods: {
    formatDate,
    getAge,

    async init() {
      let { logo } = userData();

      this.logo = logo;

      this.loading = true;
      try {
        const [configRes, residentRes] = await Promise.all([
          api.get(
            "/rest-home/settings/config-resident-print-prescription-lote"
          ),
          api.get(
            "/rest-home/settings/config-resident-print-default/resident",
            {
              params: { resident_id: this.resident_id },
            }
          ),
        ]);

        // ── Processa configuração ──────────────────────────────────
        // Se a API retornar null (ILPI nunca configurou), usa o DEFAULT inteiro.
        // Se retornar dados, faz merge: DEFAULT é a fonte dos campos disponíveis,
        // o salvo é a fonte dos valores selected — mesmo padrão do ConfigResidentPrintDefault.
        if (!configRes.data.error) {
          let saved = configRes.data.print_sections;

          if (saved) {
            // Normaliza double-encoded ("\"[...]\"" → [...])
            if (typeof saved === "string") {
              saved = JSON.parse(saved);
              if (typeof saved === "string") saved = JSON.parse(saved);
            }
            const merged = this.mergeSections(DEFAULT_PRINT_SECTIONS, saved);
            this.configMap = this.buildConfigMap(merged);
          } else {
            // null do banco → aplica o DEFAULT sem merge
            this.configMap = this.buildConfigMap(DEFAULT_PRINT_SECTIONS);
          }
        }

        // ── Processa dados do residente ────────────────────────────
        if (!residentRes.data.error) {
          this.resident = residentRes.data.resident;
        }
      } catch (e) {
        console.error("[ResidentDataPrintDefault] Erro ao inicializar:", e);
      } finally {
        this.loading = false;
      }
    },

    /**
     * Transforma o array de seções em um mapa para lookup O(1).
     *
     * Entrada (array):
     *   [{ key: "general", selected: true, fields: [{ key: "name", selected: true }] }]
     *
     * Saída (mapa):
     *   { general: { selected: true, fields: { name: true } } }
     */
    buildConfigMap(sections) {
      const map = {};
      sections.forEach((section) => {
        const fieldsMap = {};
        if (section.fields) {
          section.fields.forEach((f) => {
            fieldsMap[f.key] = f.selected;
          });
        }
        map[section.key] = {
          selected: section.selected,
          fields: fieldsMap,
        };
      });
      return map;
    },

    /**
     * Merge entre DEFAULT_PRINT_SECTIONS (fonte dos campos disponíveis)
     * e o array salvo no banco (fonte dos valores selected).
     *
     * Garante que campos novos adicionados ao DEFAULT no futuro apareçam
     * automaticamente sem quebrar configurações já salvas — idêntico ao
     * comportamento do ConfigResidentPrintDefault.
     */
    mergeSections(defaults, saved) {
      return defaults.map((defaultSection) => {
        const savedSection = saved.find((s) => s.key === defaultSection.key);
        if (!savedSection) return { ...defaultSection };

        const mergedFields = defaultSection.fields.map((defaultField) => {
          const savedField = savedSection.fields
            ? savedSection.fields.find((f) => f.key === defaultField.key)
            : null;
          return savedField
            ? { ...defaultField, selected: savedField.selected }
            : { ...defaultField };
        });

        return {
          ...defaultSection,
          selected: savedSection.selected,
          fields: mergedFields,
        };
      });
    },

    /**
     * Verifica se uma SEÇÃO inteira está habilitada na configuração.
     * Se não houver configuração salva (configMap vazio), exibe tudo por padrão.
     *
     * @param {string} sectionKey - ex: "general", "hosting"
     */
    isSection(sectionKey) {
      if (!this.configMap[sectionKey]) return true; // sem config → exibe
      return this.configMap[sectionKey].selected === true;
    },

    /**
     * Verifica se um CAMPO específico está habilitado na configuração.
     * A seção pai precisa estar habilitada (isSection) para que qualquer campo apareça.
     *
     * @param {string} sectionKey - ex: "general"
     * @param {string} fieldKey   - ex: "name"
     */
    isField(sectionKey, fieldKey) {
      if (!this.isSection(sectionKey)) return false;
      const section = this.configMap[sectionKey];
      if (!section || section.fields[fieldKey] === undefined) return true; // sem config → exibe
      return section.fields[fieldKey] === true;
    },
  },
};
</script>

<style>
.rdpd-root table {
  border: none !important;
}

.rdpd-root {
  background-color: white !important;
  border: none !important;
}

.rdpd-root .logo {
  width: 100px !important;
  height: 100px !important;
  object-fit: contain !important;
}

.rdpd-root .rest_home_logo_url {
  width: 100px !important;
  height: 100px !important;
  object-fit: cover !important;
}

.rdpd-root .resident_photo_url {
  width: 100px !important;
  height: 100px !important;
  border-radius: 50% !important;
  object-fit: cover !important;
}

.rdpd-root .content-data-card {
  margin-bottom: 2px !important;
}
</style>